import { useState, useEffect } from 'react'

export const useForgotPasswordPage = (forgotPassword) => {
  const [email, setEmail] = useState('')
  const [status, setStatus] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const handleSendForgotPassword = async (e) => {
    setLoading(true)
    e.preventDefault()
    try {
      const { data } = await forgotPassword(email)
      setStatus(data.message)
    } catch (e) {
      setError('There was an error sending your email.')
    }
    setLoading(false)
  }

  const handleEmailChange = (e) => {
    setEmail(e.target.value)
  }

  useEffect(() => {
    const savedEmail = localStorage?.getItem('email')
    setEmail(savedEmail || '')
  }, [])

  return {
    email,
    status,
    loading,
    error,
    handleSendForgotPassword,
    handleEmailChange,
  }
}
